module.exports = __webpack_public_path__ + "front/img/edm-bj-xianxia.c3a1602e.png";